import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=b0a4cea4&"
import script from "./AddTeam.vue?vue&type=script&lang=js&"
export * from "./AddTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports